import _ from 'lodash';
import { Layout } from '@/types';

export const areLayoutsEqual = (a: Layout, b: Layout) => {
  const OMIT_PROPS = ['createdAt'];
  return _.isEqual(_.omit(a, OMIT_PROPS), _.omit(b, OMIT_PROPS));
};
